import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { ExternalStorageSideMenuRef } from '../../components/ExternalStorage'
import { ExternalStorageForm } from '../../components/ExternalStorage'

interface Props {
  sideMenuRef: React.RefObject<ExternalStorageSideMenuRef>
}

const ExternalStoragePage = ({ sideMenuRef }: Props): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>External Storage</title>
      <meta name="description" content="External Storage page" />
    </Helmet>
    <ExternalStorageForm sideMenuRef={sideMenuRef} />
  </React.Fragment>
)

export default ExternalStoragePage
